import React, { Component } from 'react'
import { getSingleEventWagers } from '../../api-calls/wagers';
import CreatorName from '../layoutComponents/CreatorName';
import { takeWager as takeContractWager } from '../../contract/WagersController'
import { takeWager as takeWagerApi } from '../../api-calls/wagers'
import { Popconfirm, message, Icon } from 'antd'
import { inject, observer } from 'mobx-react'
const ethMultiplier = 1000000000000000000;
const roundingMultiplier = 1000000000;
@observer(["AuthStore", "UserStore", "WagerStore", "web3Store"])
export default class AvailablePropBets extends Component {

    constructor(props) {
        super(props);
        this.state = {
            finalArrayOfBets: <Icon type="loading" />
        }
    }

    componentDidMount() {
        let self = this;
        const AuthStore = this.props.AuthStore;
        getSingleEventWagers(this.props.propEvent._id).then((wagers) => {
            let betArray = [];
            wagers.forEach(bet => {
                if (bet.taker == null && !bet.cancelled && !bet.isPrivate && bet.makerChoice == self.props.teamBetsAreAgainst) {
                    let potentialWin;
                    let selectedTeamColor;
                    let selectedTeamName;
                    let rightOrLeft;

                    if (bet.odds > 99) {
                        potentialWin = bet.value / (bet.odds / 100);
                    } else {
                        potentialWin = bet.value * Math.floor(100 / bet.odds);

                    }

                    if (bet.makerChoice == 2) {
                        selectedTeamName = this.props.propEvent.teams[0];
                        selectedTeamColor = this.props.teamOneColor;
                        rightOrLeft = "left";
                    } else {
                        selectedTeamName = this.props.propEvent.teams[1];
                        selectedTeamColor = this.props.teamTwoColor;
                        rightOrLeft = "top";
                    }

                    let popTitle = <div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            {/* <div><img src={selectedTeamLogo} width="75" /></div> */}
                            <div style={{ padding: '2px 0px 0px 6px' }}>You are betting for <strong style={{ textTransform: 'uppercase', letterSpacing: '1px', color: selectedTeamColor }}>{selectedTeamName}</strong> to win</div>
                        </div>
                        <div>You are <strong style={{ textTransform: 'uppercase', letterSpacing: '1px', color: "#FFF" }}>betting {(potentialWin/ethMultiplier).toFixed(4)} ETH to win {(bet.value/ethMultiplier).toFixed(4)} ETH</strong></div>
                    </div>
                    let takeBetButton =
                        <Popconfirm placement={rightOrLeft} onConfirm={() => {message.warning("You must be logged in to take bets!")}} title={popTitle} okText="Confirm" cancelText="Cancel">
                            <button className="custom-btn-primary">Take Bet</button>
                        </Popconfirm>
                    if (AuthStore.userAuth.auth) {
                        takeBetButton =
                            <Popconfirm placement={rightOrLeft} title={popTitle} onConfirm={this.takeBet.bind(this, bet)} okText="Confirm" cancelText="Cancel">
                                <button className="custom-btn-primary">Take Bet</button>
                            </Popconfirm>
                    }



                    betArray.push(
                        <div className="single-event-page-card-wagers-component-wager" key={bet._id}>
                            <div className="single-event-page-card-wagers-component-wager-details">
                                <div>Potential Win: <span style={{ fontWeight: '400' }}>{(Math.round(bet.value * roundingMultiplier)/ethMultiplier / roundingMultiplier).toFixed(4)} ETH</span></div>
                                <div>Odds: <span style={{ fontWeight: '400' }}>{bet.odds / 100} : 1</span></div>
                                <div>Creator: <CreatorName userId={bet.maker} /></div>
                                <div>To Take: <span style={{ fontWeight: '600' }}>{(Math.round(potentialWin * roundingMultiplier)/ethMultiplier / roundingMultiplier).toFixed(4)} ETH</span></div>
                            </div>
                            <div className="single-event-page-card-wagers-component-take-btn">
                                {takeBetButton}
                            </div>
                        </div>
                    )
                }
            });
            self.setState({ finalArrayOfBets: betArray })
        });
    }


    takeBet(wager) {
        const { web3Store, AuthStore, UserStore, WagerStore } = this.props;
        let token = AuthStore.userAuth.auth.accessToken;
        let amountToTake;

        if (wager.odds > 99) {
            amountToTake = (wager.value) / (wager.odds / 100);
        } else {
            amountToTake = (wager.value) * Math.floor(100 / wager.odds);

        }

        //console.log("wager to take " + JSON.stringify(wager));
        //console.log("endTime" + start_time+duration);
        if (Date.now() > (wager.startTime + wager.duration) * 1000) {
            message.info("You can't take bets, the event has finished.");
        } else {
            console.log("wager.odds " + wager.odds);
            console.log("wager.value " + wager.value);
            console.log(wager.value / (wager.odds / 100));
          //  console.log("DIV -- " + Math.floor((wager.value * ethMultiplier) / Math.floor(wager.odds / 100)));
            takeContractWager(wager.bytes32Id, amountToTake).then( //SUBTRACT 1 from maker choice becasue contract (0= team one) and (1= team 2)

                function (result) {
                    if (String(result).includes('User denied transaction signature')) {
                        message.warning("Metamask transaction denied! No bet made.");
                    } else {
                        return takeWagerApi(token,
                            UserStore.user._id,
                            wager._id,
                            wager.bytes32Id,
                            amountToTake,
                            web3Store.account,
                            wager.eventId,
                            wager.makerChoice).then(function () {
                                // WagerStore.queryEventWagers(wager.eventId);
                                return UserStore.updateUser(token);
                            });
                    }
                });
        }

    }

    render() {
        return (
            <div>
                {/* BEts to take against team {this.props.teamBetsAreAgainst} */}
                {this.state.finalArrayOfBets}

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/layoutComponents/AvailablePropBets.js